import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./style.css"

function SuperLightBox(props) {

  const {children, open, handler} = props;
    
  return (
    <>
     <Modal show={open} onHide={handler}>
        <Modal.Body className="superLightbox">

            {/* CLOSE BUTTON */}
            <div className="btn-close">
                <Button variant="link link-success btn-close" onClick={handler}>
                    <i className="fe fe-x-circle"></i>
                </Button>
            </div>

            {/* CONTENT */}
            <div className="contact-us text-center">
                {children}
            </div>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default SuperLightBox;

